import index from "../views/index";
import leaderSay from "../views/about/leaderSay";
import intro from "../views/about/intro";
import history from "../views/about/history";
import organization from "../views/about/organization";
import certification from "../views/about/certification";
import honor from "../views/about/honor";
import culture from "../views/culture";
import idea from "../views/team/idea";
import partner from "../views/team/partner";
import empowerment from "../views/team/empowerment";
import teamStyle from "../views/team/teamStyle";
import teamJob from "../views/team/job";
import job from "../views/contact/job";
import productType from "../views/product/productType";
import warning from "../views/product/warning";
import valueSystem from "../views/product/valueSystem";
import qualityControl from "../views/product/qualityControl";
import productCenter from "../views/innovate/productCenter";
import academe from "../views/innovate/academe";
import controlPlatform from "../views/innovate/controlPlatform";
import cases from "../views/case/case";
import caseDetail from "../views/case/caseDetail";
import performance from "../views/case/performance";
import client from "../views/case/client";
import map from "../views/contact/map";
import company from "../views/news/company";
import event from "../views/news/event";
import report from "../views/news/report";
import industry from "../views/news/industry";
import newDetail from "../views/news/newDetail";
import policy from "../views/files/policy";
import information from "../views/files/information";
import standard from "../views/files/standard";
import fileDetail from "../views/files/fileDetail";

export const menuRoutes = [
  {
    path: "/",
    name: "首页",
    component: index,
    meta: {},
  },
  {
    path: "/news/company",
    name: "公司动态",
    component: company,
  },
  {
    path: "/news/event",
    name: "新闻事件",
    component: event,
  },
  {
    path: "/news/report",
    name: "公益事业报道",
    component: report,
  },
  {
    path: "/news/industry",
    name: "行业相关",
    component: industry,
  },
  {
    path: "/news/newDetail/:id",
    name: "新闻详情",
    component: newDetail,
  },
  {
    path: "/about/leaderSay",
    name: "创始人说",
    component: leaderSay,
  },
  {
    path: "/about/intro",
    name: "企业简介",
    component: intro,
  },
  {
    path: "/about/history",
    name: "发展历程",
    component: history,
  },
  {
    path: "/about/organization",
    name: "组织架构",
    component: organization,
  },
  {
    path: "/about/certification",
    name: "企业资质",
    component: certification,
  },
  {
    path: "/about/honor",
    name: "企业荣誉",
    component: honor,
  },
  {
    path: "/culture",
    name: "志扬文化",
    component: culture,
  },
  {
    path: "/team/idea",
    name: "用人理念",
    component: idea,
  },
  {
    path: "/team/empowerment",
    name: "人才赋能",
    component: empowerment,
  },
  {
    path: "/team/teamStyle",
    name: "团队风采",
    component: teamStyle,
  },
  {
    path: "/team/partner",
    name: "企业合伙人",
    component: partner,
  },
  {
    path: "/team/job",
    name: "招贤纳士",
    component: teamJob,
  },
  {
    path: "/product/productType",
    name: "产品类别",
    component: productType,
  },
  {
    path: "/product/qualityControl",
    name: "品控体系",
    component: qualityControl,
  },
  {
    path: "/product/warning",
    name: "风控预警",
    component: warning,
  },
  {
    path: "/product/valueSystem",
    name: "价值再造",
    component: valueSystem,
  },
  {
    path: "/innovate/productCenter",
    name: "产品中心",
    component: productCenter,
  },
  {
    path: "/innovate/controlPlatform",
    name: "云控平台",
    component: controlPlatform,
  },
  {
    path: "/innovate/academe",
    name: "志扬学苑",
    component: academe,
  },
  {
    path: "/case/client",
    name: "合作客户",
    component: client,
  },
  {
    path: "/case/case",
    name: "代表案例",
    component: cases,
  },
  {
    path: "/case/case/caseDetail/:id",
    name: "案例详情",
    component: caseDetail,
  },
  {
    path: "/case/performance",
    name: "公司业绩",
    component: performance,
  },
  {
    path: "/case/performance/performanceDetail/:id",
    name: "详情",
    component: caseDetail,
  },
  {
    path: "/contact/job",
    name: "人才招聘",
    component: job,
  },
  {
    path: "/contact/map",
    name: "地图展示",
    component: map,
  },
  {
    path: "/files/policy",
    name: "政策规范",
    component: policy,
  },
  {
    path: "/files/information",
    name: "价材信息",
    component: information,
  },
  {
    path: "/files/standard",
    name: "指标数据",
    component: standard,
  },
  {
    path: "/files/detail/:id",
    name: "资源详情",
    component: fileDetail,
  },
];
